import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';  
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LegendsComponent } from './home/legends/legends.component';
import { StatsComponent } from './home/stats/stats.component';
import { AboutusComponent } from './home/aboutus/aboutus.component';



@NgModule({
   declarations: [
      AppComponent,
      HomeComponent,
      LegendsComponent,
      StatsComponent,
      AboutusComponent
   ],
   imports: [
      BrowserModule,
      MDBBootstrapModule.forRoot(),
      AppRoutingModule,
      HttpClientModule
   ],
   providers: [],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
